<template>
	<div v-if="!isAdminUser" class="deprecation-overlay d-flex align-center justify-center appGrey">

		<div class="d-flex flex-column align-center pa-4" style="min-width: 256px; width: 100%; max-width: 512px">

			<!--Logo-->
			<div class="d-flex justify-center">
				<v-img :src="require('@/assets/images/company-logo.svg')"
					   style="min-width: 256px; width: 100%; max-width: 256px"/>
			</div>

			<v-divider class="mt-8" style="width: 100%"/>

			<app-text class="text-center mt-8" color="primary" size="medium-bold">
				This platform has been replaced by a new version.
			</app-text>

			<app-text class="text-center mt-4">
				You'll receive instructions on how to access SWAPP3 shortly.
			</app-text>

			<app-text class="text-center mt-4">
				If you have any questions in the meantime, please contact your administrator.
			</app-text>

			<app-btn @click.native="handleSignOutUser"
					 class="mt-8"
					 label="Sign Out"/>

		</div>

	</div>
</template>

<script>
export default {
	name: "DeprecationBanner",

	computed: {
		isAdminUser() {
			const userData = JSON.parse(localStorage.getItem('currentUserData') || '{}')
			return userData?.userLevel === 'Staff-Admin'
		}
	},

	methods: {

		async handleSignOutUser() {
			const t = this

			const RESPONSE = await t.MIX_auth_signOutUser()

			if (RESPONSE.hasErrors) {
				console.error('Error Signing Out User: ', RESPONSE.error)
				return
			}

			t.MIX_go('/signIn')
		}

	}
}
</script>

<style scoped>
.deprecation-overlay {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 9999;
}
</style>
